import { defineComponent as F, ref as g, computed as y, resolveComponent as R, openBlock as a, createElementBlock as r, normalizeClass as h, createElementVNode as f, normalizeStyle as w, Fragment as u, renderList as z, createBlock as S, withKeys as H, createTextVNode as p, toDisplayString as n, createCommentVNode as k } from "vue";
import N from "../VIconButton/VIconButton.js";
import $ from "../../molecules/VFormFieldHidden/VFormFieldHidden.js";
import { useSpacingClass as M } from "../../../composables/useSpacingClass.js";
import { _ as W } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../VIcon/VIcon.js";
import "../../../vee-validate.esm-c4518011.js";
const U = F({
  name: "VRating",
  emits: ["update:rating"],
  components: { VFormFieldHidden: $, VIconButton: N },
  props: {
    maxRating: {
      type: Number,
      default: 5
    },
    rating: {
      type: Number,
      default: 0
    },
    ratingName: {
      type: String,
      required: !0
    },
    validateRating: {
      type: Boolean,
      default: !1
    },
    starSize: {
      type: Number,
      default: 24
    },
    alignRight: {
      type: Boolean,
      default: !1
    },
    showCurrentRating: {
      type: Boolean,
      default: !1
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    bottomSpacing: {
      type: String,
      default: "",
      validator: (e) => ["xs", "s", "m", "l", "xl", ""].includes(e)
    },
    topSpacing: {
      type: String,
      default: "",
      validator: (e) => ["xs", "s", "m", "l", "xl", ""].includes(e)
    },
    formatRatingDecimals: {
      type: Boolean,
      default: !1
    },
    wrapAverageRating: {
      type: Boolean,
      default: !1
    },
    translator: {
      type: Function,
      required: !0,
      default: (e) => e
    }
  },
  setup(e, { emit: m }) {
    const d = g(-1), b = (i) => {
      d.value = i;
    }, v = () => {
      d.value = -1;
    }, o = g(e.rating), c = (i) => {
      i === o.value ? (o.value = 0, v()) : o.value = i, m("update:rating", o.value);
    }, l = g(e.starSize), t = g(e.maxRating), s = y(() => ({
      backgroundSize: l.value + "px",
      height: l.value + "px"
    })), V = y(() => ({
      width: t.value * l.value + "px"
    })), B = y(() => {
      const i = t.value * l.value, D = Math.round(
        o.value * 100 / t.value
      );
      return {
        maxWidth: i + "px",
        width: D + "%"
      };
    }), { topSpacingClass: C, bottomSpacingClass: I } = M(e);
    return {
      currentRating: o,
      hoverIndex: d,
      activateHoverIndex: b,
      deactivateHoverIndex: v,
      rate: c,
      starStyles: s,
      barStyles: V,
      meterStyles: B,
      topSpacingClass: C,
      bottomSpacingClass: I
    };
  },
  methods: {
    formatDecimals(e) {
      return this.formatRatingDecimals ? e.toFixed(1) : e;
    }
  }
});
const A = { class: "hobi-rating__stars tw-flex tw-flex-row tw-items-center" }, K = { "aria-hidden": "true" }, q = { class: "hobi-visually-hidden" };
function E(e, m, d, b, v, o) {
  const c = R("VIconButton"), l = R("VFormFieldHidden");
  return a(), r("div", {
    class: h(["hobi-rating tw-flex tw-flex-col tw-items-start", [
      e.alignRight ? "hobi-rating--right-aligned tw-items-end" : "",
      e.topSpacingClass,
      e.bottomSpacingClass
    ]])
  }, [
    f("div", A, [
      e.readonly ? (a(), r("div", {
        key: 0,
        class: "hobi-rating-star-bar tw-block",
        style: w([e.starStyles, e.barStyles])
      }, [
        f("span", {
          class: "hobi-rating-star-bar__meter tw-block",
          style: w([e.starStyles, e.meterStyles])
        }, null, 4)
      ], 4)) : (a(!0), r(u, { key: 1 }, z(e.maxRating, (t) => (a(), S(c, {
        key: "hobi-rating_" + t,
        size: e.starSize,
        symbol: "rating-star",
        "button-label": t + " " + e.translator("rating.of") + " " + e.formatDecimals(e.maxRating) + " " + e.translator("rating.ofUnit"),
        class: h(["hobi-rating-star", {
          "hobi-rating-star--rated": t <= e.currentRating && e.hoverIndex === -1,
          "hobi-rating-star--hovered": t <= e.hoverIndex
        }]),
        onClick: (s) => e.rate(t),
        onMouseenter: (s) => e.activateHoverIndex(t),
        onMouseleave: e.deactivateHoverIndex,
        onKeydown: H((s) => e.rate(t), ["enter"]),
        onFocus: (s) => e.activateHoverIndex(t),
        onBlur: e.deactivateHoverIndex
      }, null, 8, ["size", "button-label", "class", "onClick", "onMouseenter", "onMouseleave", "onKeydown", "onFocus", "onBlur"]))), 128)),
      e.showCurrentRating ? (a(), r("div", {
        key: 2,
        class: h([
          "hobi-rating-current-rating tw-inline-block tw-text-xs tw-font-obi tw-text-orange tw-ml-2 tw-leading-4",
          e.wrapAverageRating ? "hobi-rating-current-rating__grey tw-text-gray-600 tw-font-normal tw-text-sm" : "tw-font-bold "
        ])
      }, [
        f("span", K, [
          e.currentRating <= e.maxRating ? (a(), r(u, { key: 0 }, [
            p(n(e.wrapAverageRating ? "(" + e.formatDecimals(e.currentRating) + ")" : e.formatDecimals(e.currentRating)), 1)
          ], 64)) : (a(), r(u, { key: 1 }, [
            p(n(e.formatDecimals(e.maxRating)), 1)
          ], 64))
        ])
      ], 2)) : k("", !0),
      f("div", q, [
        e.currentRating <= e.maxRating ? (a(), r(u, { key: 0 }, [
          p(n(e.formatDecimals(e.currentRating)) + " " + n(e.translator("rating.of")) + " " + n(e.formatDecimals(e.maxRating)) + " " + n(e.translator("rating.ofUnit")), 1)
        ], 64)) : (a(), r(u, { key: 1 }, [
          p(n(e.formatDecimals(e.maxRating)) + " " + n(e.translator("rating.of")) + " " + n(e.formatDecimals(e.maxRating)) + " " + n(e.translator("rating.ofUnit")), 1)
        ], 64))
      ])
    ]),
    e.validateRating ? (a(), S(l, {
      key: 0,
      id: e.ratingName,
      name: e.ratingName,
      modelValue: e.currentRating,
      "onUpdate:modelValue": m[0] || (m[0] = (t) => e.currentRating = t),
      "show-error": e.validateRating
    }, null, 8, ["id", "name", "modelValue", "show-error"])) : k("", !0)
  ], 2);
}
const Q = /* @__PURE__ */ W(U, [["render", E], ["__scopeId", "data-v-f958c507"]]);
export {
  Q as default
};
